/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
  tableBodyClasses,
  OutlinedInput,
  ButtonBase,
} from "@mui/material";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function OrderEdit(props) {
  const { login, onClosePop, seq } = props;
  const token = localStorage.getItem("token");

  // 변수 하나로
  const [data, setData] = useState({
    regdate: "regdate",
    updated: "updated",
    cname: "cname",
    type: "type",
    mname: "mname",
    mphone: "mphone",
    is_point: "is_point",
    review_url: "review_url",
    state: "",
    reason: "",
    tname: "",
  });

  const onSubmit = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/review_edit",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
        state: data.state,
        tname: data.tname,
        reason: data.reason,
        type: data.type,
        review_url: data.review_url,
      }
    );

    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "수정되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClosePop();
        }
      );
    }

    // 푸시 보내기
    if (result.data.success === 1 && result.data.is_push === "Y") {
      await axios.post(configState.api + "/push/to_mcd", {
        cid: result.data.cid,
        mcd: result.data.mcd,
        title: "캐시",
        message: `리뷰 이벤트가 인증되어 캐시가 적립되었습니다.`,
      });
    }
  };

  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/review_one",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
      }
    );

    if (result.data.success === 1) {
      setData((state) => {
        return {
          ...state,
          regdate: result.data.row.regdate,
          updated: result.data.row.updated,
          cname: result.data.row.cname,
          type: result.data.row.type,
          mname: result.data.row.mname,
          mphone: result.data.row.mphone,
          is_point: result.data.row.is_point,
          review_url: result.data.row.review_url,
          state: result.data.row.state,
          reason: result.data.row.reason,
          tname: result.data.row.tname,
        };
      });
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  const onDeleteClick = () => {
    Swal.fire({
      title: "삭제하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(
            configState.api + "/gympass_admin/review_del",
            {
              token: token,
              cid: login.cid,
              level: login.level,
              mcd: login.mcd,
              seq: seq,
            }
          );
          if (result.data.success === 1) {
            onClosePop();
          } else {
            Swal.fire(result.data.msg);
          }
        }
      })
      .catch((e) => alert(e));
  };

  useEffect(() => {
    load_data();
  }, []);

  const handleData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  return (
    <Box>
      <Box p={2}>
        <Box marginTop={1} display="flex">
          <Box>등록일 : {data.regdate} </Box>
          <Box marginLeft={3}>수정일 : {data.updated} </Box>
        </Box>

        <Box mt={1}>센터명 : {data.cname}</Box>

        <Box mt={1}>타입 : {data.type}</Box>

        <Box marginTop={1} display="flex">
          <Box>고객명 : {data.mname} </Box>
          <Box marginLeft={3}>연락처 : {data.mphone} </Box>
        </Box>

        <Box mt={1}>포인트지급 : {data.is_point}</Box>

        <Box marginTop={1} display="flex">
          <Box>리뷰주소 :</Box>
          <Box marginLeft={3} style={{ flex: "1", marginRight: "1rem" }}>
            <TextField
              type="text"
              value={data.review_url}
              variant="outlined"
              label="리뷰주소"
              size="small"
              style={{ width: "100%" }}
              name="review_url"
              onChange={handleData}
            />
          </Box>
          <Button
            variant="contained"
            onClick={() => {
              window.open(data.review_url, 'target="_blank"');
            }}
          >
            바로가기
          </Button>
        </Box>

        <FormControl fullWidth style={{ marginTop: "10px" }}>
          <FormLabel>상태</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="female"
            name="state"
            onChange={handleData}
            value={data.state}
          >
            <FormControlLabel
              value="회원등록"
              control={<Radio />}
              label="회원등록"
            />
            <FormControlLabel
              value="승인완료"
              control={<Radio />}
              label="승인완료"
            />
            <FormControlLabel
              value="승인거절"
              control={<Radio />}
              label="승인거절"
            />
            <TextField
              name="tname"
              label="담당자"
              size="small"
              sx={{
                width: "120px",
              }}
              autoComplete="off"
              value={data.tname}
              onChange={handleData}
            ></TextField>
          </RadioGroup>
        </FormControl>

        <Box marginTop={2}>
          <FormControl fullWidth>
            <TextField
              name="reason"
              label="승인거절사유"
              size="small"
              style={{ width: "100%" }}
              autoComplete="off"
              multiline
              maxRows={2}
              value={data.reason}
              onChange={handleData}
              inputProps={{
                style: {
                  height: 50,
                  width: 300,
                },
              }}
            ></TextField>
          </FormControl>
        </Box>

        <Box style={{ textAlign: "center", marginTop: "30px" }}>
          <Button variant="contained" onClick={onSubmit}>
            수정완료
          </Button>

          <Button
            variant="contained"
            style={{ marginLeft: "10px" }}
            onClick={onClosePop}
          >
            닫기
          </Button>

          {login.level === "500" && (
            <Button
              variant="contained"
              color="warning"
              style={{ marginLeft: "10px" }}
              onClick={onDeleteClick}
            >
              삭제
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default OrderEdit;
